import React, { useState } from 'react';
import Chart      from './Chart';
import jsonData   from './data/data.json'; // Import the JSON file

const App = () => {
  // const [ isLoading,       setIsLoading ]       = useState(false);
  const [ showInput,       setShowInput ]       = useState(true);
  const [ age,             setAge ]             = useState('');
  const [ gender,          setGender ]          = useState('MALE');
  const [ sexPartners,     setSexPartners ]     = useState(0);
  const [ showNote,        setShowNote ]        = useState(false);
  const [ data,            setData ]            = useState([]);
  const [ percentageArray, setPercentageArray ] = useState([]);
  const [ comparisonValue, setComparisonValue ] = useState(100);
  

  // Event on gender change
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  // Start from begining
  const backToStart = () => {
    setShowInput(true);
    setAge('');
    setGender('MALE');
    setSexPartners(0);
    setShowNote(false);
    setData([]);
    setPercentageArray([]);
    setComparisonValue(100);
  }

  // Prevent submiting form
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  // Parsing Logic
  const parsingLogic = (jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender) => {
    const filteredData = jsonData.filter(item => {
      return item.ageGroup === ageGroup && item.sex === gender;
    });
    //const filteredData = jsonData.filter(item => item.ageGroup === ageGroup);
    const filteredDataUnderAge = filteredData.filter(item => item.sexualPartners <= sexPartners);
    setData(filteredData);
    
    let totalResponders     = filteredData.length + 1;
    let underAgeResponders  = filteredDataUnderAge.length + 1;
    let comparisonValueCalc = (underAgeResponders * 100 / totalResponders).toFixed(0);
    setComparisonValue(comparisonValueCalc);

    // Step 1: Count occurrences of each number of sexual partners
    const countMap = {};
    filteredData.forEach(entry => {
    // !!! filteredDataUnderAge.forEach(entry => {
      const partners     = entry.sexualPartners;
      countMap[partners] = (countMap[partners] || 0) + 1;
    });

    // Step 2: Calculate the percentage for each count
    const totalCount = filteredData.length;
    // !!!! const totalCount = filteredDataUnderAge.length;
    const percentageMap = {};
    Object.keys(countMap).forEach(key => {
      const count = countMap[key];
      const percentage = Math.round((count / totalCount) * 100);
      percentageMap[key] = percentage;
    });

    // Step 3: Create a new array with percentages ranging from 0 to 100
    const newArr = Array.from({ length: 101 }, (_, i) => percentageMap[i] || 0);
    // Find the index of the last non-zero element
    let lastNonZeroIndex = newArr.length - 1;
    while (lastNonZeroIndex >= 0 && newArr[lastNonZeroIndex] === 0) {
      lastNonZeroIndex--;
    }

    // Create a new array with only the elements up to the last non-zero index
    // trimmedArr = newArr.slice(0, lastNonZeroIndex + 1);  ORIGINAL!!
    let trimmedArr = [];
    if ( sexPartners <= 55 ) {
      trimmedArr = newArr.slice(0, 56);
    }
    else {
      trimmedArr = newArr.slice(0, lastNonZeroIndex + 1);
    }
    
    setPercentageArray(trimmedArr);

    console.log('Gender ',                gender);
    console.log('new arr: ',              newArr);
    console.log('trimmedArr arr: ',       trimmedArr);
    console.log('total Responders = ',    totalResponders);
    console.log('Under Age total = ',     underAgeResponders);
    console.log('Comparsion value %  = ', comparisonValue);
  }


  const sexCalculation = (e) => {
    e.preventDefault();
    console.log('age = ', age, ' sex partn = ', sexPartners);
    if (age >= 18 && age <= 99  && sexPartners >=0) {
    setShowNote(false);

    // ***** Calculations *******
		switch (gender) {
      // *********** for MALE
      case 'MALE':
          if (age >= 18 && age <= 21) {
            let ageGroup = ('18-21');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 22 && age <= 24) {
            let ageGroup = ('22-24');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 25 && age <= 29) {
            let ageGroup =('25-29');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 30 && age <= 34) {
            let ageGroup = ('30-34');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 35 && age <= 39) {
            let ageGroup = ('35-39');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 40 && age <= 44) {
            let ageGroup = ('40-44');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 45 && age <= 49) {
            let ageGroup = ('45-49');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 50 && age <= 54) {
            let ageGroup = ('50-54');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 55 && age <= 59) {
            let ageGroup = ('55-59');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 60 && age <= 64) {
            let ageGroup = ('60-64');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 65 && age <= 69) {
            let ageGroup = ('65 to 69');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 70) {
            let ageGroup = ('>=70');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else {
            console.log('Age ERROR');
          }
          break;

      //  **********  for FEMALE
      case 'FEMALE':
          if (age >= 18 && age <= 21) {
            let ageGroup = ('18-21');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 22 && age <= 24) {
            let ageGroup = ('22-24');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 25 && age <= 29) {
            let ageGroup = ('25-29');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 30 && age <= 34) {
            let ageGroup = ('30-34');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 35 && age <= 39) {
            let ageGroup = ('35-39');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 40 && age <= 44) {
            let ageGroup = ('40-44');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 45 && age <= 49) {
            let ageGroup = ('45-49');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 50 && age <= 54) {
            let ageGroup = ('50-54');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 55 && age <= 59) {
            let ageGroup = ('55-59');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 60 && age <= 64) {
            let ageGroup = ('60-64');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 65 && age <= 69) {
            let ageGroup = ('65 to 69');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else if (age >= 70) {
            let ageGroup = ('>=70');
            parsingLogic(jsonData, ageGroup, sexPartners, setData, setComparisonValue, setPercentageArray, gender);
          } else {
            console.log('Age Error');
          }
          break;

      default:
      // Handle default case
      break;
    }
      setShowInput(false);
    }
    else {
      setShowNote(true);
    }
    
  }

  return (

  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-6 col-md-10 col-12">

        <div id="bedbible_calculator">

        { showInput && 

          <div id="input_block">
            <h1 className="text-center">What’s your number?</h1>
            <form onSubmit={handleSubmit} className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12">

                  <div className="row g-3 align-items-center">
                    <div className="col-lg-6 col-md-6 col-4">
                      <label htmlFor="age" className="col-form-label">What's your gender?</label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-4">
                      <div className="form-check">
                        <input 
                          checked={gender === 'MALE'}
                          onChange={handleGenderChange}
                          className="form-check-input" type="radio" name="gender" id="male" value="MALE" 
                        ></input>
                        <label className="form-check-label" htmlFor="male">
                          Male
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-4">
                      <div className="form-check">
                        <input 
                          checked={gender === 'FEMALE'}
                          onChange={handleGenderChange}
                          className="form-check-input" type="radio" name="gender" id="female" value="FEMALE"
                        ></input>
                        <label className="form-check-label" htmlFor="female">
                          Female
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row g-3 align-items-center pt-3">
                    <div className="col-lg-8 col-md-8 col-8">
                      <label htmlFor="age" className="col-form-label">How old are you?</label>
                    </div>
                    <div className="col-lg-4 col-md-4 col-4">
                      <input onChange={(e) => setAge(e.target.value)}
                        type="number" className="form-control" id="age" placeholder="your age" min="18" max="99"></input>
                    </div>
                  </div>

                  <div className="row g-3 align-items-center pt-3">
                    <div className="col-lg-8 col-md-8 col-8">
                      <label htmlFor="sexPartners" className="col-form-label">How many sex partners have you had since age 18?</label>
                    </div>
                    <div className="col-lg-4 col-md-4 col-4">
                      <input onChange={(e) => setSexPartners(e.target.value)}
                      type="number" className="form-control" id="sexPartners" placeholder="partners" min="1"></input>
                    </div>
                  </div>

                  <div className="row g-3 justify-content-center pt-3">
                    <div className="col-auto text-center">
                      {showNote && <p id="validation_message">Note: please enter valid information</p>}
                      <button  id="submit_btn" onClick={sexCalculation} className="btn btn-primary">See Your Score!</button>
                      <span id="passwordHelpInline" className="form-text d-block">
                        Don't worry, we're not collecting your data.
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </form> 
          </div>

        }

        { !showInput && 

          <div id="results_block">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 text-center">
                  {/* <div>Gender: <span id="result_gender">{gender}</span></div>
                  <div>Age: <span id="result_age">{age}</span></div>
                  <div>Sex Partners: <span id="result_sex_partners">{sexPartners}</span></div> */}
                  <Chart 
                    sexPartners={sexPartners}
                    comparisonValue={comparisonValue} 
                    percentageArray={percentageArray}
                    gender={gender}
                  />
                  <div id="peers">
                      You've had more sexual partners than <b><span id="comparisonValue">{comparisonValue}</span>%</b> of people your age.
                  </div>
                  <button  id="back_btn" onClick={backToStart} type="submit" className="btn btn-primary">
                    <span id="lied">I Lied.</span>
                    <span id="again">Let Me Try Again</span>
                  </button>
                  <div className="fluid">
                    <a className="btn btn-sm btn-social btn-fb" href="http://www.facebook.com/sharer.php?u=https://bedbible.com/sex-calculator/" target="_blank" rel="noreferrer" title="Share Sex history calculator">
                        <i className="fab fa-facebook-square"></i> Share
                    </a>
                    <a className="btn btn-sm btn-social btn-tw" href="https://twitter.com/intent/tweet?text=Bedbible calculator just told me everything I ever wanted to know but was afraid to ask about my sex life.&amp;url=https://bedbible.com/sex-calculator/" target="_blank" rel="noreferrer" title="Share Sex history calculator">
                      <i className="fab fa-x-twitter"></i>
                    </a>
                    <a className="btn btn-sm btn-social btn-email" href="mailto:?subject=Bedbible calculator just told me everything I ever wanted to know but was afraid to ask about my sex life.&body=Why not ask it about yours? https://bedbible.com/sex-calculator/ " target="_blank" rel="noreferrer"  title="Share this post by email">
                      <i className="fa-regular fa-envelope-open"></i> Email
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        }

        </div>
      </div>
    </div>
  </div>
          
  );
};

export default App;
